<vb-loading-spinner *ngIf="status.isLoading" [size]="'medium'" [block]="true">
</vb-loading-spinner>

<div class="modal-header">
	<h4 id="modal-title">
		{{ 'Media_Integrations_AutoIngest_ViewLog' | translate }}
	</h4>
	<button type="button" class="close btn btn-transparent" (click)="close()" [attr.aria-label]="'Close' | translate">
		<span class="glyphicons remove_2"></span>
	</button>
</div>

<auto-ingest-logs-grid *ngIf="status.active" [data]="logs">
</auto-ingest-logs-grid>
